import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import ChangeOrgUserTag from "@/views/MGT/modal/ChangeOrgUserTag";
import AppDetailSync from "@/views/MGT/AppDetail/AppDetailCom/app-detail-sync.vue";
import { getAccountCreationConfig } from "@/service/appList.js";
import { configAppScope, editAccountCreationConfig, syncUsers } from "@/service/appList";
import { encrypt, decrypt } from "@/libs/rsa";
export default {
  name: "app-detail-bind-modal",
  components: {
    ChangeOrgUserTag,
    AppDetailSync
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    detail: {
      type: Object,
      default() {
        return {};
      }
    },
    scopeList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      step: 1,
      form: {
        accountCreationRule: "AUTO_NAME",
        accountCodePrefix: "",
        passwordCreationRule: "DOWNSTREAM_DEFAULT",
        defaultPassword: "",
        triggerSync: "T"
      }
    };
  },
  computed: {
    _modalTitle() {
      let title = "";
      if (this.step === 1) {
        title = $t("ikvpwe4", "选择人员");
      } else if (this.step === 2) {
        title = $t("ns8blc7", "人员同步至应用");
      }
      return title;
    },
    _isPmsUc() {
      return this.item.code === "UC" || this.item.code === "PMS" || this._isOperaCloud;
    },
    // opera
    _isOperaCloud() {
      // return this.detail.appId === "ID_OPERA_CLOUD";
      return false;
    },
    _unitId() {
      return this.$store.state.user.userInfo.unitId;
    }
  },
  methods: {
    close() {
      this.step = 1;
      this.form = {
        accountCreationRule: "AUTO_NAME",
        accountCodePrefix: "",
        passwordCreationRule: "DOWNSTREAM_DEFAULT",
        defaultPassword: ""
      };
      this.modal.visible = false;
      this.modal.loading = false;
    },
    open() {
      // let {}
      this.modal.visible = true;
      if (this._isPmsUc) {
        this.getInitSync();
      }
    },
    async getInitSync() {
      let res = await getAccountCreationConfig(this.item.code);
      if (res.data && res.data.result == 0) {
        res.data.retVal.defaultPassword = res.data.retVal.defaultPassword.replace("\\n", "\n");
        if (res.data.retVal.accountCreationRule) {
          this.form.accountCreationRule = res.data.retVal.accountCreationRule;
        }
        if (res.data.retVal.passwordCreationRule) {
          this.form.passwordCreationRule = res.data.retVal.passwordCreationRule;
        }
        if (!this._isOperaCloud) {
          this.form.accountCodePrefix = res.data.retVal.accountCodePrefix;
        }
        this.form.defaultPassword = decrypt(res.data.retVal.defaultPassword);
      }
    },
    onStep(step) {
      this.step = step;
    },
    async onSubmit() {
      if (this._isPmsUc) {
        if (this.form.accountCreationRule === "AUTO_NAME" && this.form.accountCodePrefix && this.form.passwordCreationRule === "CUSTOM") {
          if (!this.form.defaultPassword) {
            this.$Message.warning($t("9horr45", "请填写密码"));
            return;
          }
        }
      }
      let tagIds = [];
      let orgIds = [];
      let userIds = [];
      let checkTree = this.$refs["ChangeOrgUserTag"].getCheckTree();
      checkTree.map(v => {
        if (v.userId) {
          userIds.push(v.userId);
        } else if (v.tagId) {
          tagIds.push(v.tagId);
        } else {
          orgIds.push(v.orgId);
        }
      });
      const params = {
        appId: this.item.id,
        unitId: this._unitId,
        tagIds,
        orgIds,
        userIds,
        isHalt: this.detail.isHalt
      };
      this.modal.loading = true;
      let res = await configAppScope(params);
      this.modal.loading = false;
      if (res.data && res.data.result === 0) {
        if (this._isPmsUc) {
          this.onSubmitSync();
        } else {
          this.$Message.success($t("ai8d7e4", "修改成功"));
          this.$emit("on-update");
          this.close();
        }
      }
    },
    /*
     * 同步
     */
    async onSubmitSync() {
      const defaultPassword = this.form.passwordCreationRule === "CUSTOM" ? encrypt(this.form.defaultPassword) : "";
      const params = {
        ...this.form,
        defaultPassword
      };
      this.modal.loading = true;
      let res = await editAccountCreationConfig(this.item.code, params);
      this.modal.loading = false;
      if (res.data && res.data.result === 0) {
        this.successApi();
      }
    },
    successApi() {
      this.$Message.success($t("ai8d7e4", "修改成功"));
      this.$emit("on-update");
      this.close();
      this.onsubmitUser();
    },
    /*
     *
     */
    async onsubmitUser() {
      await syncUsers("any");
    }
  }
};